import React from "react";
import "./About.css";

export default class About extends React.Component {
  render() {
    return (
      <div className="aboutContainer">
        <h4>
          This is an simple example using several components that come in the
          React library.
        </h4>
        <h6>Made by Frankroz</h6>
      </div>
    );
  }
}